
import { type AxiosResponse } from 'axios';
import { type ApiResponse } from '@teamworksdev/influencer/core';

function handleResponse<T>(response: AxiosResponse<T, any>): ApiResponse<T> {
	return {
		data: response.data,
		status: response.status,
	};
}

export {
	handleResponse,
};
